// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Vmg-","delete":"styles_delete__2REih","update":"styles_update__3yrt3","add":"styles_add__1Ma9J"};